import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ColorSlot {
  label: string;
  hexCode: string | null;
}

export interface BrandKitColorsState {
  lastSynced: number | null;
  colors: ColorSlot[];
}

const initialState: BrandKitColorsState = {
  lastSynced: null,
  colors: [
    { label: 'Primary', hexCode: null },
    { label: 'Secondary', hexCode: null },
    { label: 'Accent', hexCode: null }
  ]
};

const brandKitColorsSlice = createSlice({
  name: 'brandKitColors',
  initialState,
  reducers: {
    updateColor: (state, action: PayloadAction<{ index: number; hexCode: string }>) => {
      const { index, hexCode } = action.payload;
      if (index >= 0 && index < state.colors.length) {
        state.colors[index].hexCode = hexCode;
      }
    },
    addColor: state => {
      state.colors.push({ label: 'Custom', hexCode: null });
    },
    removeColor: (state, action: PayloadAction<number>) => {
      const index = action.payload;
      if (index >= 0 && index < 3) {
        // For the first 3 colors (Primary, Secondary, Accent), we clear the hexCode instead of removing the slot
        state.colors[index].hexCode = null;
      } else if (index >= 3 && index < state.colors.length) {
        state.colors.splice(index, 1);
      }
    },
    loadColorsSuccess: (state, action: PayloadAction<ColorSlot[]>) => {
      state.colors = action.payload;
    },
    setLastSynced: (state, action: PayloadAction<number>) => {
      state.lastSynced = action.payload;
    }
  }
});

export const { updateColor, addColor, removeColor, loadColorsSuccess, setLastSynced } = brandKitColorsSlice.actions;

export default brandKitColorsSlice.reducer;
